/** pfh-mobile-only UI strings. Merged last in src/i18n.ts. */
export const mobileEn = {
  mobile: {
    password: { show: 'Show password', hide: 'Hide password' },
    deleteAccount: {
      title: 'Delete account',
      open: 'Delete my account',
      warning: 'This permanently erases your account and all your data in Naforo, Yiriba and Kelen, and cancels any paid plan. It cannot be undone.',
      password: 'Your password',
      confirm: 'Permanently delete',
      deleting: 'Deleting…',
      cancel: 'Cancel',
    },
    nav: {
      home: 'Home', accounts: 'Accounts', portfolio: 'Portfolio', more: 'More',
      transactions: 'Transactions', recurring: 'Recurring', spending: 'Spending', forecasts: 'Forecasts',
      budgets: 'Budgets', goals: 'Goals', debts: 'Debts', jeliLab: 'Jeli Lab', importLog: 'Import log',
      etf: 'ETF', crypto: 'Crypto', analysis: 'Analysis', backtest: 'Backtest', screener: 'Screener',
      compare: 'Compare', news: 'News', profile: 'Profile', settings: 'Settings', security: 'Security',
      household: 'Household', markets: 'Markets', tax: 'Tax', whatIf: 'What-If', import: 'Import', legal: 'Legal',
    },
    mfa: {
      title: 'Two-step verification', method: 'Verification method',
      totpHint: 'Enter the 6-digit code from your authenticator app.',
      emailHint: 'We send a 6-digit code to {{email}}.',
      methods: { totp: 'Authenticator app', email_otp: 'Email code' },
      send: 'Send code by email', resend: 'Send a new code', code: 'Code',
      verify: 'Verify', verifying: 'Verifying…', back: 'Back to sign in',
    },
    stepup: {
      declined: { body: 'Verify it is you to see your {{app}} data.', action: 'Verify now' },
      loading: 'Checking your verification options…',
      enroll: {
        title: 'Set up your verification',
        body: "You haven't set up a way to confirm it's you yet. We'll email you a 6-digit code to switch on email verification for {{app}}.",
        codeBody: 'Enter the 6-digit code we just emailed you. If you cannot see it, check your Spam folder.',
        send: 'Email me a code', sending: 'Sending…', confirm: 'Turn on and continue', confirming: 'Checking…',
      },
      recovery: {
        title: 'Save your recovery codes',
        body: 'Keep these one-time codes somewhere safe. Each one works once if you ever lose access to your email. They are shown only now.',
        saved: "I've saved them",
      },
      hint: {
        totp: 'Open your authenticator app and enter the current 6-digit code.',
        email_otp: 'We emailed you a 6-digit code. If it is not in your inbox, check Spam.',
        recovery_code: 'Enter one of your saved recovery codes. Each code works only once.',
      },
      sent: 'Code sent. It can take a minute to arrive.',
      resend: 'Send a new code', resendIn: 'Send a new code in {{s}}s',
      errors: {
        wrong: 'That code is wrong or has expired. Check it and try again.',
        rateLimited: 'Too many attempts. Wait a minute and try again.',
        emailUnavailable: 'We cannot send email right now. Try again later.',
        network: 'No connection. Check your internet and try again.',
        failed: 'Something went wrong. Try again.',
      },
      title: 'Confirm it is you',
      body: 'For your security, {{app}} needs a fresh verification.',
      methods: { totp: 'Authenticator app', email_otp: 'Email code', recovery_code: 'Recovery code' },
      send: 'Send code by email', code: 'Code', verify: 'Verify', verifying: 'Verifying…',
      cancel: 'Not now', failed: 'That code did not work. Try again.',
    },
    routeError: {
      title: 'Something went wrong', body: 'This screen could not be displayed.',
      status: 'This screen could not be displayed (error {{status}}).', home: 'Back to home',
    },
  },
}

export const mobileIt = {
  mobile: {
    password: { show: 'Mostra password', hide: 'Nascondi password' },
    deleteAccount: {
      title: 'Elimina account',
      open: 'Elimina il mio account',
      warning: 'Cancella in modo permanente il tuo account e tutti i tuoi dati in Naforo, Yiriba e Kelen e annulla qualsiasi piano a pagamento. Non può essere annullato.',
      password: 'La tua password',
      confirm: 'Elimina definitivamente',
      deleting: 'Eliminazione…',
      cancel: 'Annulla',
    },
    nav: {
      home: 'Home', accounts: 'Conti', portfolio: 'Portafoglio', more: 'Altro',
      transactions: 'Transazioni', recurring: 'Ricorrenti', spending: 'Spese', forecasts: 'Previsioni',
      budgets: 'Budget', goals: 'Obiettivi', debts: 'Debiti', jeliLab: 'Jeli Lab', importLog: 'Registro import',
      etf: 'ETF', crypto: 'Crypto', analysis: 'Analisi', backtest: 'Backtest', screener: 'Screener',
      compare: 'Confronta', news: 'Notizie', profile: 'Profilo', settings: 'Impostazioni', security: 'Sicurezza',
      household: 'Famiglia', markets: 'Mercati', tax: 'Fisco', whatIf: 'What-If', import: 'Importa', legal: 'Note legali',
    },
    mfa: {
      title: 'Verifica in due passaggi', method: 'Metodo di verifica',
      totpHint: "Inserisci il codice a 6 cifre dell'app di autenticazione.",
      emailHint: 'Inviamo un codice a 6 cifre a {{email}}.',
      methods: { totp: 'App di autenticazione', email_otp: 'Codice via email' },
      send: 'Invia codice via email', resend: 'Invia un nuovo codice', code: 'Codice',
      verify: 'Verifica', verifying: 'Verifica…', back: "Torna all'accesso",
    },
    stepup: {
      declined: { body: 'Confirmez que c\'est bien vous pour voir vos données {{app}}.', action: 'Vérifier' },
      loading: 'Controllo le opzioni di verifica…',
      enroll: {
        title: 'Configura la verifica',
        body: 'Non hai ancora un modo per confermare la tua identità. Ti invieremo un codice di 6 cifre via email per attivare la verifica via email per {{app}}.',
        codeBody: 'Inserisci il codice di 6 cifre che ti abbiamo appena inviato via email. Se non lo vedi, controlla lo Spam.',
        send: 'Inviami un codice', sending: 'Invio…', confirm: 'Attiva e continua', confirming: 'Controllo…',
      },
      recovery: {
        title: 'Salva i codici di recupero',
        body: 'Conserva questi codici monouso in un posto sicuro. Ognuno funziona una sola volta se perdi l’accesso alla tua email. Vengono mostrati solo ora.',
        saved: 'Li ho salvati',
      },
      hint: {
        totp: 'Apri la tua app di autenticazione e inserisci il codice di 6 cifre attuale.',
        email_otp: 'Ti abbiamo inviato un codice di 6 cifre via email. Se non è nella posta in arrivo, controlla lo Spam.',
        recovery_code: 'Inserisci uno dei tuoi codici di recupero. Ogni codice funziona una sola volta.',
      },
      sent: 'Codice inviato. Può servire un minuto per arrivare.',
      resend: 'Invia un nuovo codice', resendIn: 'Nuovo codice tra {{s}}s',
      errors: {
        wrong: 'Il codice è errato o scaduto. Controllalo e riprova.',
        rateLimited: 'Troppi tentativi. Attendi un minuto e riprova.',
        emailUnavailable: 'Al momento non possiamo inviare email. Riprova più tardi.',
        network: 'Nessuna connessione. Controlla internet e riprova.',
        failed: 'Qualcosa è andato storto. Riprova.',
      },
      title: 'Conferma la tua identità',
      body: 'Per la tua sicurezza, {{app}} richiede una nuova verifica.',
      methods: { totp: 'App di autenticazione', email_otp: 'Codice via email', recovery_code: 'Codice di recupero' },
      send: 'Invia codice via email', code: 'Codice', verify: 'Verifica', verifying: 'Verifica…',
      cancel: 'Non ora', failed: 'Codice non valido. Riprova.',
    },
    routeError: {
      title: 'Qualcosa è andato storto', body: 'Impossibile mostrare questa schermata.',
      status: 'Impossibile mostrare questa schermata (errore {{status}}).', home: 'Torna alla home',
    },
  },
}

export const mobileFr = {
  mobile: {
    password: { show: 'Afficher le mot de passe', hide: 'Masquer le mot de passe' },
    deleteAccount: {
      title: 'Supprimer le compte',
      open: 'Supprimer mon compte',
      warning: 'Cela efface définitivement votre compte et toutes vos données dans Naforo, Yiriba et Kelen, et annule tout abonnement payant. Cette action est irréversible.',
      password: 'Votre mot de passe',
      confirm: 'Supprimer définitivement',
      deleting: 'Suppression…',
      cancel: 'Annuler',
    },
    nav: {
      home: 'Accueil', accounts: 'Comptes', portfolio: 'Portefeuille', more: 'Plus',
      transactions: 'Transactions', recurring: 'Récurrents', spending: 'Dépenses', forecasts: 'Prévisions',
      budgets: 'Budgets', goals: 'Objectifs', debts: 'Dettes', jeliLab: 'Jeli Lab', importLog: "Journal d'import",
      etf: 'ETF', crypto: 'Crypto', analysis: 'Analyse', backtest: 'Backtest', screener: 'Screener',
      compare: 'Comparer', news: 'Actualités', profile: 'Profil', settings: 'Paramètres', security: 'Sécurité',
      household: 'Foyer', markets: 'Marchés', tax: 'Fiscalité', whatIf: 'What-If', import: 'Importer', legal: 'Mentions légales',
    },
    mfa: {
      title: 'Vérification en deux étapes', method: 'Méthode de vérification',
      totpHint: "Saisissez le code à 6 chiffres de votre application d'authentification.",
      emailHint: 'Nous envoyons un code à 6 chiffres à {{email}}.',
      methods: { totp: "Application d'authentification", email_otp: 'Code par e-mail' },
      send: 'Envoyer le code par e-mail', resend: 'Envoyer un nouveau code', code: 'Code',
      verify: 'Vérifier', verifying: 'Vérification…', back: 'Retour à la connexion',
    },
    stepup: {
      declined: { body: 'Conferma che sei tu per vedere i tuoi dati {{app}}.', action: 'Verifica ora' },
      loading: 'Vérification des options…',
      enroll: {
        title: 'Configurez votre vérification',
        body: "Vous n'avez pas encore de moyen de confirmer votre identité. Nous vous enverrons un code à 6 chiffres par e-mail pour activer la vérification par e-mail pour {{app}}.",
        codeBody: "Saisissez le code à 6 chiffres que nous venons de vous envoyer par e-mail. Si vous ne le voyez pas, vérifiez vos spams.",
        send: 'Envoyez-moi un code', sending: 'Envoi…', confirm: 'Activer et continuer', confirming: 'Vérification…',
      },
      recovery: {
        title: 'Enregistrez vos codes de secours',
        body: "Conservez ces codes à usage unique en lieu sûr. Chacun ne fonctionne qu'une fois si vous perdez l'accès à votre e-mail. Ils ne sont affichés que maintenant.",
        saved: "Je les ai enregistrés",
      },
      hint: {
        totp: "Ouvrez votre application d'authentification et saisissez le code à 6 chiffres actuel.",
        email_otp: "Nous vous avons envoyé un code à 6 chiffres par e-mail. S'il n'est pas dans votre boîte de réception, vérifiez les spams.",
        recovery_code: "Saisissez l'un de vos codes de secours. Chaque code ne fonctionne qu'une fois.",
      },
      sent: "Code envoyé. Il peut mettre une minute à arriver.",
      resend: 'Envoyer un nouveau code', resendIn: 'Nouveau code dans {{s}}s',
      errors: {
        wrong: 'Ce code est incorrect ou a expiré. Vérifiez-le et réessayez.',
        rateLimited: 'Trop de tentatives. Attendez une minute et réessayez.',
        emailUnavailable: "Impossible d'envoyer des e-mails pour le moment. Réessayez plus tard.",
        network: 'Pas de connexion. Vérifiez votre connexion et réessayez.',
        failed: 'Une erreur est survenue. Réessayez.',
      },
      title: "Confirmez qu'il s'agit bien de vous",
      body: 'Pour votre sécurité, {{app}} demande une nouvelle vérification.',
      methods: { totp: "Application d'authentification", email_otp: 'Code par e-mail', recovery_code: 'Code de récupération' },
      send: 'Envoyer le code par e-mail', code: 'Code', verify: 'Vérifier', verifying: 'Vérification…',
      cancel: 'Plus tard', failed: "Ce code n'a pas fonctionné. Réessayez.",
    },
    routeError: {
      title: "Une erreur s'est produite", body: "Impossible d'afficher cet écran.",
      status: "Impossible d'afficher cet écran (erreur {{status}}).", home: "Retour à l'accueil",
    },
  },
}
